import React from "react";
import {  Routes, Route, useLocation, matchPath } from "react-router-dom"
//import user from "../services/methods/user";
import { useUser } from "../services/StateContext";

import Layout from "./../layout"

import Form from '../Pages/Cpf'

import ConvenioParticular from '../Pages/ConvenioParticular'
import Convenio           from '../Pages/Convenios'
// const Procedimento  = React.lazy(() => import('../Pages/Procedimento')) 
import Plano              from '../Pages/Plano' 
import Especialidade      from '../Pages/Especialidades' 
import Dia                from '../Pages/Dia' 
import Profissional       from '../Pages/Profissional'
import Agendado           from '../Pages/Agendado'
import CentralAgendamento from "../Pages/CentralAgendamento"
import Auth               from "../Components/Auth"
import Cadastro           from "../Pages/Cadastro"

// import { history } from "services/history"


const AppRoutes = () => {
         
    const { setProgress } = useUser()

    const location = useLocation()
    //const navigate = useNavigate()

    React.useEffect(() => {
        window.scrollTo(0, 0) //Go to top on every page load
        
        if (location) {
            
            const stages = [
                '/',
                'cadastro', 
                'particular-ou-convenio', 
                'convenio'     ,  
                'especialidade', 'dia', 
                'profissional' , 'obrigado'
            ]
            
            const totalStages = stages.length - 1

            const stage = stages.findIndex( path => matchPath(path, location.pathname))
            const progress = stage === 0 ? 0 : 100 /  totalStages * stage
            
            // const currentState = prevState => {
            //     return {...prevState, progress }
            // }

            setProgress(progress)
        }
        window.history.index = 0
        // eslint-disable-next-line
    }, [location.pathname, setProgress])
    
    return (
        <Routes >
            <Route path="/" element={<Layout />}>
                <Route index element={<Form/>} />
                
                    <Route 
                        path="cadastro" 
                        element={ <Auth>
                            <Cadastro />
                        </Auth>}  
                    />
                    <Route 
                        path="particular-ou-convenio" 
                        element={ <Auth>
                            <ConvenioParticular />
                        </Auth>}  
                    />
                    <Route 
                        path="central-agendamento"    
                        element={
                            <CentralAgendamento /> 
                        } 
                    />
                    <Route 
                        path="convenio" 
                        element={<Auth>
                            <Convenio />
                        </Auth>}
                    />
                    <Route 
                        path="plano" 
                        element={<Auth>
                            <Plano />
                        </Auth>} 
                    />
                    <Route 
                        path="especialidade" 
                        element={<Auth>
                            <Especialidade />
                        </Auth>} 
                    />
                    <Route 
                        path="dia" 
                        element={<Auth>
                            <Dia totalByPerPage={6} />
                        </Auth>} 
                    />
                    <Route 
                        path="profissional" 
                        element={<Auth>
                            <Profissional />
                        </Auth>} 
                    />  
                    <Route 
                        path="obrigado" 
                        element={
                            //<Agendado />
                            <Auth>
                                <Agendado />
                            </Auth>
                        } 
                    />  
                
                <Route path="*" element={<CentralAgendamento/> } /> 
            </Route>    
        </Routes>  
    )
}

export default AppRoutes